import { StyleSheet, Text } from "@react-pdf/renderer"
import React from "react"
import PropTypes from "prop-types"

const styles = StyleSheet.create({
  header: {
    fontSize: 16,
    marginBottom: 16,
    textAlign: 'center',
    color: 'black',
  },
})

const Header = ({ text }) => (
  <Text style={styles.header} wrap={true}>{text}</Text>
)

Header.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Header
